import React , {useEffect} from 'react';
import {Link} from 'react-router-dom'
import {AiFillYoutube,AiFillInstagram,AiFillFacebook} from 'react-icons/ai'
const Home = () => {
    return (
        <>
            <header style={{backgroundImage:'url(../img/headphone/headphone1.jpg)'}}>
                <div className='header_main'>
                    <div className="header_text animate__animated animate__flash animate__delay-2s">
                        <h2>NEW PRODUCTS</h2>
                        <h3>XX99 MARK II</h3>
                        <h3>HEADPHONES</h3>
                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam ab, consequatur quis recusandae laborum repellat explicabo, non quas tempora nostrum porro debitis voluptatem pariatur aliquam!</p>
                        <button><Link className='link' to='/headphone'>See Products</Link></button>
                    </div>
                </div>
            </header>
            {/* <div className="section_1">
                <div className="item_container">
                    <h3>headphone</h3>
                    <Link className='link'><p className='link'>Shop <MdKeyboardArrowRight/></p></Link>
                    <div className="item_img">
                        <img src='../img/headphone/headphone2.jpg' alt="" />
                    </div>
                </div>
                <div className="item_container">
                    <h3>headphone</h3>
                    <Link className='link'><p className='link'>Shop <MdKeyboardArrowRight/></p></Link>
                    <div className="item_img">
                        <img src='../img/speaker_img/speaker2.jpg' alt="" />
                    </div>
                </div>
                <div className="item_container">
                    <h3>headphone</h3>
                    <Link className='link'><p className='link'>Shop <MdKeyboardArrowRight/></p></Link>
                    <div className="item_img">
                        <img src='../img/earphone/earphone2.jpg' alt="" />
                    </div>
                </div>
            </div> */}
            <div style={{backgroundImage:'url(../img/speaker_img/speaker2.jpg)'}} className="section_2">
                <div className="speaker_text animate__animated animate__swing animate__delay-5s">
                    <h4>zx9 speaker</h4>
                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis sapiente libero asperiores vero dolores incidunt fuga voluptates, non numquam aliquid?</p>
                    <button><Link to='/speaker' className='link'>See Products</Link></button>
                </div>
            </div>
            <div style={{backgroundImage:'url(../img/headphone/headphone1.jpg)'}} className="section_3">
                <div className='speaker2_text'>
                <h4>zx7 headphone</h4>
                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis sapiente libero asperiores vero dolores incidunt fuga voluptates, non numquam aliquid?</p>
                    <button><Link to='/headphone' className='link'>See Products</Link></button>
                </div>
            </div>

            <div className="section_4">
                <div className='section_4_img'>
                    <img src="../img/earphone/earphone3.jpg" alt="" />
                </div>
                <div className="section_4_text">
                    <h3>YXI EARPHONE</h3>
                    <Link  to='/earphone' className='link'><button>See Products</button></Link>
                </div>
            </div>
            <div className="section_5">
                <div className="left_side">
                    <h3>bringing you to the best audio gear</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cupiditate nobis, molestiae natus fugit alias officia laboriosam hic aspernatur eligendi temporibus asperiores sequi blanditiis reprehenderit.</p>
                </div>
                <div className="right_side">
                    <img src="../img/girl_listen.jpg" alt="" />
                </div>
            </div>
            <div className="footer">
            <footer>
                <div className="footer_left">
                    <h3>audiophile</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia, magnam delectus! Distinctio iure obcaecati hic omnis officiis eveniet nesciunt, dignissimos recusandae debitis quam rem, illo at repellendus laudantium beatae nemo.</p>
                    <p>Copyright 2021 All Rights Reserved</p>
                </div>
                <div className="footer_right">
                <div className="nav_link">
                        <ul className="link_group">
                            <li>
                                <Link className="link" to='/'>Home</Link>
                            </li>
                            <li>
                                <Link className="link" to='/headphone'>Headphones</Link>
                            </li>
                            <li>
                                <Link className="link" to='speaker'>Speakers</Link>
                            </li>
                            <li>
                                <Link className="link" to='earphone'>Earphones</Link>
                            </li>
                        </ul>
                        <div className='social_footer'>
                            <Link className='social' to=''>
                            <AiFillFacebook/>
                            </Link>
                            <Link className='social' to=''>
                            <AiFillInstagram/>
                            </Link>
                            <Link className='social' to=''>
                            <AiFillYoutube/>
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
            </div>
            
        </>
    )
}

export default Home
